import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_TIME_MY_TIME_GET_WORK_TIME_WEEKLY_DATA } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeWorkTimeWeeklyData = ({
  contractCode,
  date,
}: {
  contractCode: string;
  date: string;
}) => {
  const { data, loading, error, refetch } = useQuery(
    MY_TIME_MY_TIME_GET_WORK_TIME_WEEKLY_DATA,
    {
      fetchPolicy: "cache-and-network",
      skip: !contractCode || !date,
      variables: {
        contractCode,
        date,
      },
    },
  );

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    skip: !data,
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getWorkTimeWeeklyData,
    loading,
    error,
  };
};

export default useMyTimeWorkTimeWeeklyData;
